function DangerButton({ text, onClick }) {

    return (

        <button
            className="btn-danger"
            onClick={onClick}
        >

            {text}

        </button>

    );

}

export default DangerButton;